import React from 'react'

const constitution = () => {
  return (
    <>
    <div className="audit-page">
        <section className="audit-cover constitution">
           <div className="container">
              <div className="audit-cover-para">
                <h1 style={{color: "#f1f1f1", fontSize: "42px"}}>CONSTITUTION OF A BUSINESS</h1>
              </div>
           </div>
        </section>

        <section className="audit-page-content container" style={{marginBottom: "40px"}}>
             <p>We provide a complete solution for formation of a company, proprietorship firm, partnership firm, LLP etc. For carrying out various business services.</p>             <div className="serv">
               <div className='inclu1'>
                  <p><strong>Our Services includes:</strong></p>
                  <p>&#x2022; Form a company, proprietorship firm, partnership firm, LLP etc</p>
                  <p>&#x2022; Start-up advisory</p>
                  <p>&#x2022; Start-up India registration</p>
                  <p>&#x2022; Various compliances related to ROC for running a company, LLP etc</p>
                  <p>&#x2022; Tax Planning.</p>
                  <p>&#x2022; Funding applications and loan applications from various funding Agencies for various companies</p>
                  <p>&#x2022; Services like change of name of company, add or remove director etc</p>
                  <p>&#x2022; Strike off of a company etc</p>
                  <h6><strong>We work as Virtual CFO for various corporates.</strong></h6>
                  <p><strong>We provide a complete business outsourcing services and accountancy outsourcing services to the corporates.</strong></p>
                  <p>&#x2022; Start up advisory.</p>
                  <p>&#x2022; Design and Implementation of Accounting and Costing.</p>
                  <p>&#x2022; Management Services and Risk Analysis.</p>
                  <p>&#x2022; Advice on Merger, Sale of Business and related due diligence and valuations.</p>
                  <p>&#x2022; Tax Planning.</p>
                  <p>&#x2022; Consulting and Advice on FEMA/RBI matters.</p>
                  <p>&#x2022; Assessment of working capital requirements etc</p>
               </div>
               {/* <div className='inclu2'>
                  <img src={Cons} alt="" />
               </div> */}
             </div>
          </section>
    </div> 
  </>
  )
}

export default constitution
